var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xl-6 xl-100"},[_c('px-card',{attrs:{"title":"Market Value"}},[_c('div',{staticClass:"card-body"},[_c('apexchart',{attrs:{"type":"bar","height":"380","options":_vm.chartOptions,"series":_vm.series}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }